import _ from 'lodash';
import timm from 'timm';

import { Types }                from 'app/actions/company-dashboards';
import { Types as CadminTypes } from 'app/actions/company-admin/company-dashboards';
import utils                    from 'app/reducers/utils';

const initialState = {};

const reducer = utils.createReducer(initialState, {

  [`${CadminTypes.GET}_RESOLVED`]: (state, {result: {companyDashboard}}) => {
    return timm.mergeIn(state, [companyDashboard.id], companyDashboard);
  },

  [`${CadminTypes.UPDATE}_RESOLVED`]: (state, {result: {companyDashboard}}) => {
    return timm.mergeIn(state, [companyDashboard.id], companyDashboard);
  },

  [`${Types.GET_DATA}_RESOLVED`]: (state, {result: {companyDashboard}}) => {
    return timm.mergeIn(state, [companyDashboard.id], companyDashboard);
  },

});

export default reducer;
